export const themeMiddleware = store => next => action => {
  const result = next(action);

  if (action.type === 'SET_DARK_MODE') {
    localStorage.setItem('@polichat/darkmode', action.payload ? 'true' : 'false');
    document.body.classList.toggle('darkMode', action.payload);
  }

  if (action.type === 'REQUEST_LOGIN_SUCCESS') {
    setTimeout(() => {
      applyInitialTheme(store);
    }, 100);
  }

  return result;
};

export const applyInitialTheme = (store) => {
  const state = store.getState();
  const isDarkMode = state?.theme?.isDarkMode;

  if (isDarkMode) {
    document.body.classList.add('darkMode');
  } else {
    document.body.classList.remove('darkMode');
  }
};
